import { createElement, useState } from "react";
import { Trans } from "react-i18next";
import { deleteHttp } from "@common/api/apiShared";
import { useDotLegalSnackbar } from "@dotlegal/dotlegal-ui-components";
import { useDotLegalMutation } from "@common/hooks/dotLegalReactQuery";
import { DeletionResultWithBlockers } from "@common/components/deleteBlockedDialog/DeleteBlockedDialog.types";
import { IDeleteExternalUserDialogProps } from "./DeleteExternalUserDialog";

export function useDeleteExternalUserDialogHook(props: IDeleteExternalUserDialogProps) {
    const snackbar = useDotLegalSnackbar();
    const [blockedDeletion, setBlockedDeletion] = useState<DeletionResultWithBlockers | undefined>();

    const removeMutation = useDotLegalMutation(remove);
    const removeExternalUser = () => {
        removeMutation.mutateAsync(undefined, {
            onSuccess: (response: any) => {
                const result: DeletionResultWithBlockers = response.value();

                if (!result.isDeleted) {
                    setBlockedDeletion(result);
                    return;
                }

                props.onCloseDialog();
                props.onDeletion();
                snackbar.show(createElement(Trans, { i18nKey: "dataDeleted", values: { name: props.selectedExternalUser.fullName } }));
            },
        });
    };

    async function remove() {
        return await deleteHttp(`/external-users/${props.selectedExternalUser.id}`);
    }

    return {
        removeExternalUser,
        inProgress: removeMutation.isLoading,
        blockedDeletion,
    };
}
